import Judges from './Judges';

export default Judges;
